export default {
  watch: {
    courseInfo: {
      handler: function (newVal) {
        newVal.originPrice = newVal.goods.price;
        if (newVal?.promotion_info?.id) {
          newVal.activityType = 2; //促销活动
          newVal.activetyPrice = newVal.promotion_info.promotion_price / 100;
        } else if (newVal?.group_buy_info?.id) {
          newVal.activityType = 4; //拼团
          newVal.activetyPrice = newVal.group_buy_info.price / 100;
        } else if (newVal?.union?.id) {
          newVal.activityType = 3; //联报
        } else if (
          newVal.coupon_info?.id &&
          newVal.coupon_info.distribution_method === 1
        ) {
          newVal.activityType = 1; //优惠券-公开
          const { coupon_type, amount, ratio } = newVal.coupon_info;
          if (coupon_type === 1) {
            newVal.activetyPrice = (
              (newVal.originPrice - amount) /
              100
            ).toFixed(2);
          } else {
            newVal.activetyPrice = (
              (newVal.originPrice * (ratio / 100)) /
              100
            ).toFixed(2);
          }
        }
      },
      immediate: true, // 设置为true，以便在初次渲染时执行handler
    },
  },
  computed: {
    priceSize() {
      if (this.isElectron && this.needAdaptStyle) {
        return "SL1";
      } else if (this.isH5 && this.needAdaptStyle) {
        return "ML1";
      } else {
        return "SL2";
      }
    },
    activityText() {
      const activityType = this.courseInfo.activityType;
      let text = "";
      switch (activityType) {
        case 2:
          text = "促销中";
          break;
        case 3:
          text = "联报";
          break;
        case 4:
          text = "拼团";
          break;
        case 1:
          text = "领券优惠";
          break;
      }
      return text;
    },
  },
};
